import { render, staticRenderFns } from "./NativeAppUsersHeader.vue?vue&type=template&id=1341c6c3&"
import script from "./NativeAppUsersHeader.vue?vue&type=script&lang=ts&"
export * from "./NativeAppUsersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./NativeAppUsersHeader.vue?vue&type=style&index=0&id=1341c6c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports